import { stringify } from "querystring";

import { DonationFormCategory, FormType, FrontendRoutes, IsoLocale, TicketingFormCategory } from "@simplyk/common";

export interface PostFormSubmitUrlParams {
  commandId: string;
  formId: string;
  formType: FormType;
  formCategory: DonationFormCategory | TicketingFormCategory;
  isoLocale: IsoLocale;
  thankYouUrl: string;
  formUrl: string;
  organizationName: string;
  hasADate: boolean;
  generateETicket: boolean;
  generateTaxReceipt: boolean;
  organizationId: string;
  transactionId: string | null | undefined;
  productsAmount: number;
  extraDonation: number;
  currency: string | null | undefined;
}

export const buildPostFormSubmitUrl = (params: PostFormSubmitUrlParams): string => {
  const query = stringify({
    commandId: params.commandId,
    formId: params.formId,
    formType: params.formType,
    formCategory: params.formCategory,
    isoLocale: params.isoLocale,
    thankYouUrl: params.thankYouUrl,
    formUrl: params.formUrl,
    organizationName: params.organizationName,
    hasADate: String(params.hasADate),
    generateETicket: String(params.generateETicket),
    generateTaxReceipt: String(params.generateTaxReceipt),
    organizationId: params.organizationId,
    transactionId: params.transactionId ?? "",
    productsAmount: String(params.productsAmount),
    extraDonation: String(params.extraDonation),
    currency: params.currency ?? "",
  });
  return `${process.env.NEXT_PUBLIC_FRONTEND_URL}/${params.isoLocale}${FrontendRoutes.PostFormSubmit}?${query}`;
};
